import { app } from '../../../app';
import { Controller } from './applications.controller';

app.component('userApplications', {
    bindings: {
        account: '<',
        applications: '<',
registeringApplications:'<'
    },
    controller: Controller,
    templateUrl: require('./applications.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/applications.component.js